import React, { useState } from 'react';
import { Copy, Check, ExternalLink } from 'lucide-react';

const SKG_AFFILIATE_URL =
  'https://www.amazon.de/dp/B0GCHQCNG7?maas=maas_adg_E4790B72E99FB5A150206ADE89E1BDD1_afap_abs&ref_=aa_maas&tag=maas';
const DISCOUNT_CODE = 'Aaryan15';

const SkgPartnership = () => {
  const [copied, setCopied] = useState(false);

  const copyCode = () => {
    navigator.clipboard.writeText(DISCOUNT_CODE);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="skg" className="bg-black border-y border-tertiary">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        {/* Section Label */}
        <div className="mb-16">
          <span className="text-sm text-tertiary font-sans uppercase tracking-wider">Brand Partnership</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Video */}
          <div className="lg:col-span-5">
            <div className="relative max-w-sm mx-auto rounded-2xl overflow-hidden border border-tertiary shadow-2xl">
              <video
                src="/videos/skg-ifa-2026.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls
                className="w-full h-auto"
                data-testid="skg-video"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7 space-y-8">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary leading-tight">
              Partnering with{' '}
              <a
                href={SKG_AFFILIATE_URL}
                target="_blank"
                rel="sponsored noopener noreferrer"
                className="font-serif-italic text-gold underline underline-offset-4 hover:opacity-70 transition-opacity"
                data-testid="skg-brand-link"
              >
                SKG
              </a>{' '}
              at IFA Berlin 2026
            </h2>

            <div className="space-y-4 text-secondary font-sans text-base lg:text-lg leading-relaxed">
              <p>
                I teamed up with SKG — one of the leading wellness-tech brands — at IFA Berlin 2026 to
                showcase their latest neck massagers and recovery devices. After long days on my feet at
                trade shows and shoots, the SKG neck massager has genuinely become part of my daily
                wind-down routine.
              </p>
              <p>
                If you spend hours at a desk or on the go, this is the recovery upgrade I recommend the
                most. Use my exclusive code for <span className="text-gold font-medium">15% off</span> on
                Amazon.
              </p>
            </div>

            {/* Code + CTA */}
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <button
                onClick={copyCode}
                className="inline-flex items-center gap-3 px-6 py-4 border border-gold/50 rounded-lg bg-gold/5 hover:bg-gold/10 transition-colors group"
                data-testid="skg-copy-code-button"
              >
                <span className="text-xs text-tertiary font-sans uppercase tracking-wider">Code</span>
                <span className="font-mono text-lg text-gold font-semibold tracking-widest">{DISCOUNT_CODE}</span>
                {copied ? (
                  <Check className="w-4 h-4 text-gold" />
                ) : (
                  <Copy className="w-4 h-4 text-tertiary group-hover:text-gold transition-colors" />
                )}
              </button>

              <a
                href={SKG_AFFILIATE_URL}
                target="_blank"
                rel="sponsored noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gold text-black rounded-full font-sans font-medium hover:opacity-90 transition-opacity"
                data-testid="skg-affiliate-cta"
              >
                Shop SKG on Amazon
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>

            <p className="text-xs text-tertiary font-sans" data-testid="skg-affiliate-disclosure">
              Affiliate disclosure: as an affiliate partner, I may earn a commission from qualifying
              purchases made through this link — at no extra cost to you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkgPartnership;
